import React from 'react'

export default function About() {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Would you like to have a cocktail? Would you like to shine in the
        evening concocting delicious drinks for everyone? Take a look at our
        little application. You will find the name of each cocktail, the
        ingredients and the glasses suitable for each drink. Enjoy! We did it
        and we learned to use react/API routes.
      </p>
    </section>
  )
}
